import React, { type FC } from 'react'

import styled from '@emotion/styled'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Flex, Text, Toggle } from 'mailup-web-components'

import { modalUnsubscribeToggleFieldCallback } from 'Pages/RecipientsList/recoil/callbacks/modals'

import { modalUnsubscribeState } from 'Pages/RecipientsList/recoil/state/modals'

const StyledLabel = styled(Text)`
  cursor: pointer;
`

const InputSelectAllLists: FC = () => {
  const intl = useIntl()

  const { allLists } = useRecoilValue(modalUnsubscribeState)

  const toggleField = useRecoilCallback(modalUnsubscribeToggleFieldCallback, [])

  const handleToggle = (): void => {
    void toggleField('allLists')
  }

  return (
    <Flex alignItems="center" gap="8px">
      <Toggle
        data-mu-test="input-all-lists-toggle"
        variant="sm"
        checked={allLists}
        onChange={handleToggle}
        id="all-lists-toggle"
      />
      <StyledLabel htmlElement="label" htmlFor="all-lists-toggle">
        {intl.formatMessage({
          id: 'Load.RecipientsList.ModalUnsubscribeSelectAllLists',
        })}
      </StyledLabel>
    </Flex>
  )
}

export default InputSelectAllLists
